import { createAction, props } from '@ngrx/store';

export const setMapPath = createAction('[SET MAPPATH] Set', props<{ map: object }>());

